import {
  getItems,
  createItems,
  itemDataTemplate,
  getItemById,
  removeItem,
  editItem,
} from "@/http/setup/items.js";

export default {
  namespaced: true,
  state: { itemTemplate: {}, itemIdTemplate: {}, itemList: [] },
  actions: {
    async setItemTemplate({ commit }) {
      try {
        const sup = await itemDataTemplate();
        commit("ITEM_DATA_TEMPLATE", sup.data);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createItemAction(_, data) {
      try {
        return await createItems(data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setItemTemplateById({ commit }, id) {
      try {
        const sup = await getItemById(id);
        commit("SET_ITEM_TEMPLATE", sup.data);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteItemAction({ commit }, id) {
      try {
        const sup = await removeItem(id);
        commit("RESET_ITEM_LIST", id);
        return sup;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editItemAction({ commit }, data) {
      try {
        return await editItem(data.id, data.data);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setItemList({ commit }) {
      try {
        const resp = await getItems();
        commit("SET_ITEM_LIST", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    ITEM_DATA_TEMPLATE(state, payload) {
      state.itemTemplate = payload;
    },
    SET_ITEM_TEMPLATE(state, payload) {
      state.itemIdTemplate = payload;
    },
    SET_ITEM_LIST(state, payload) {
      state.itemList = payload;
    },
    RESET_ITEM_LIST(state, id) {
      state.itemList = state.itemList.filter((el) => el.id !== id);
    },
  },
  getters: {},
};
